<template>
  <div>
    <div id="pic" v-if="render === ''">
      <div class="top">
        <img class="img" src="../../assets/icon/iap.png" />
        <div crossorigin="anonymous" class="background" :style="`background-image:url('${img}')`" />
      </div>
      <div class="bottom">
        <div class="direction" :style="{ fontSize: dirFont + 'px' }">{{ direction }}</div>
        <div :style="{ fontSize: dirFont + 'px' }" id="direction" class="direction"
          style="max-width: 750px;visibility: hidden;position: absolute">{{ direction }}</div>
        <div class="dualPeople">
          <!-- 教授卡片：标题+简历在左，头像在右 -->
          <div class="personCard professorCard">
            <img class="tou professorTou" crossorigin="anonymous" :src="professor.avatar" />
            <div class="professorContent">
              <div class="professorName">
                {{ professor ? professor.academic_resume_1 : '' }}
              </div>
              <div class="resumeList professorResumeList">
                <div v-for="(item, index) in professorResumes" :key="`professor-resume-${index}`" class="resumeItem">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <!-- 导师卡片：头像在左，MENTOR标题+简历在右 -->
          <div class="personCard mentorCard">
            <img class="tou mentorTou" crossorigin="anonymous" :src="teacher.avatar" />
            <div class="mentorContent">
              <div class="mentorTitle">
                {{ teacher ? teacher.academic_resume_1 : '' }}
              </div>
              <div class="resumeList mentorResumeList">
                <div v-for="(item, index) in teacherResumes" :key="`teacher-resume-${index}`" class="resumeItem">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="qrcode" />
        <img class="psimg" src="../../assets/icon/ps.png" />
      </div>
    </div>
    <img :src="render" v-else style="width:100%" />
  </div>
</template>

<script>
import axios from '../axios'
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'

export default {
  name: 'proProPageDual',
  props: {
    pro: {}
  },
  data () {
    return {
      render: '',
      img: '',
      linesOfDer: 1,
      professor: {},
      teacher: {},
      tagsText: '',
      tags: [],
      direction: '',
      fontSize: 36,
      schoolFont: 28,
      dirFont: 28
    }
  },
  computed: {
    professorResumes() {
      return [
        this.professor.academic_resume_2,
        this.professor.academic_resume_3
      ].filter(Boolean)
    },
    teacherResumes() {
      return [
        this.teacher.academic_resume_2,
        this.teacher.academic_resume_3
      ].filter(Boolean)
    }
  },
  mounted() {
    Object.assign(this.$data, this.pro)
    const res = [this.pro.subject.content]
    this.tags = res.concat(this.tagsText.split(','))
    this.set()
    this.$nextTick(() => {
      this.initFontSize()
    })
    setTimeout(() => {
      this.exportx()
    }, 0)
  },
  methods: {
    initDover() {
      const d = this.tags.filter(Boolean)
      if (d.length >= 4) {
        this.linesOfDer = 2
        const len = []
        let max = 0
        for (const i of d) {
          max += i.length
          len.push(max)
        }
        const mid = Math.floor(max / 2)
        let key
        for (let i = 0; i < d.length; i++) {
          if (len[i] >= mid) {
            const a = Math.abs((max - len[i] + (d.length - i - 2)) - (len[i] + i))
            const b = Math.abs((max - len[i + 1] + (d.length - i - 3)) - (len[i] + i + 1))
            key = a >= b ? i + 1 : i
            break
          }
        }
        let res = ''
        for (let i = 0; i < d.length; i++) {
          res += d[i] + (i === key || i === d.length - 1 ? '\n' : ' | ')
        }
        this.direction = res
      } else {
        this.linesOfDer = 1
        let res = ''
        for (let i = 0; i < d.length; i++) {
          res += d[i] + (i === d.length - 1 ? '\n' : ' | ')
        }
        this.direction = res
      }
    },
    initFontSize() {
      let key, key2, key3
      const _this = this

      async function test() {
        for (let i = 0; i < 20; i++) {
          await _this.$nextTick(() => {
            key = document.getElementById('mirror').offsetWidth
            if (key > 250) {
              _this.fontSize -= 1
            }
          })
          if (key <= 250) {
            break
          }
        }
      }

      async function test2() {
        for (let i = 0; i < 20; i++) {
          await _this.$nextTick(() => {
            key2 = document.getElementById('school').offsetWidth
            if (key2 > 250) {
              _this.schoolFont -= 1
            }
          })
          if (key2 <= 250) {
            break
          }
        }
      }

      async function test3() {
        for (let i = 0; i < 16; i++) {
          await _this.$nextTick(() => {
            key3 = document.getElementById('direction').offsetWidth
            if (key3 > 475) {
              _this.dirFont -= 1
            }
          })
          if (key3 <= 475) {
            break
          }
        }
      }

      test()
      test2()
      test3()
    },
    set() {
      let origin = ''
      if (window.location.host.indexOf('eliteqihang') > -1) {
        origin = 'https://p.eliteqihang.com/pro/'
      } else {
        origin = 'https://p.manager.eliwise.demo.jybjts.com/pro/'
      }
      const qrcode = `${origin}${this.pro.uuid}`
      this.linesOfDer = 1
      this.initDover()
      document.getElementById('qrcode').innerHTML = ''
      new QRCode('qrcode', {
        text: qrcode,
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    exportx() {
      this.$nextTick(() => {
        document.body.style.width = '2024px'
        html2canvas(document.querySelector('#pic'), {
          useCORS: true,
          scrollY: 0,
          height: 1750
        }).then(canvas => {
          document.body.style.width = 'unset'
          this.render = canvas.toDataURL('image/jpeg', 0.9)
          const arr = this.render.split(',')
          const mime = arr[0].match(/:(.*?);/)
          const bstr = atob(arr[1])
          let n = bstr.length
          const u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          const param = new FormData()
          param.append(
            'file',
            new File(
              [u8arr],
              `${this.tags.join('、')}-${this.professor.firstName} ${this.professor.lastName}.png`,
              {
                type: mime
              }
            )
          )
          param.append('uuid', this.pro.uuid)
          param.append('type', '')
          axios
            .post('previews/upload', param, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then(res => {
              this.$emit('getPoster', res.data.url)
            })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: PFBD;
}

#pic {
  width: 375 * 2px;
  height: 875 * 2px;
  position: relative;

  .img {
    width: 375 * 2px;
    height: 392 * 2px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .background {
    width: 375 * 2px;
    height: 392 * 2px;
    top: 0;
    z-index: 0;
    background-position: top;
    background-size: cover;
    position: absolute;
  }

  .top {
    width: 375 * 2px;
    height: 392 * 2px;
    position: relative;
  }

  .bottom {
    width: 375 * 2px;
    height: 500 * 2px;
    position: relative;
    z-index: 100;
    background-color: #ffffff;

    // 方向标签（右上角）
    .direction {
      position: absolute;
      right: 80px;
      top: 20 * 2px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 14 * 2px;
      line-height: 18 * 2px;
      text-align: right;
      color: #d7af87;
      max-width: 475px;
      white-space: pre-line;
    }

    .heng {
      position: absolute;
      right: 50 * 2px;
      top: 40 * 2px;
      width: 25 * 2px;
      border-top: 2 * 2px solid #d7af87;
    }

    // 双人卡片容器
    .dualPeople {
      position: absolute;
      left: 50 * 2px;
      right: 50 * 2px;
      top: 55 * 2px;
      display: flex;
      flex-direction: column;
      gap: 75px;
    }

    // 通用头像
    .tou {
      position: absolute;
      width: 80 * 2px;
      height: 80 * 2px;
      border-radius: 50%;
      background-color: #eeeeee;
      object-fit: cover;
    }

    // 通用卡片
    .personCard {
      position: relative;
      min-height: 240px;
    }

    // ---- 教授卡片：内容在左，头像在右 ----
    .professorCard {
      .professorTou {
        top: 0;
        right: -20px;
        left: auto;
        width: 80 * 2px;
        height: 80 * 2px;
      }

      .professorContent {
        margin-right: 80 * 2px + 20px; // 留出头像宽度
        display: flex;
        flex-direction: column;
      }

      .professorName {
        text-align: left;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: normal;
        font-size: 14 * 2px;
        line-height: 20 * 2px;
        color: #d7af87;
        margin-bottom: 10px;
      }
    }

    // ---- 导师卡片：头像在左，内容在右 ----
    .mentorCard {
      .mentorTou {
        top: 0;
        left: 0;
        width: 80 * 2px;
        height: 80 * 2px;
      }

      .mentorContent {
        margin-left: 80 * 2px + 20px; // 留出头像宽度
        display: flex;
        flex-direction: column;
      }

      .mentorTitle {
        text-align: left;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: normal;
        font-size: 14 * 2px;
        line-height: 20 * 2px;
        color: #d7af87;
        margin-bottom: 10px;
      }
    }

    // 通用简历列表
    .resumeList {
      color: #555555;
      font-family: 'PingFang SC';
      font-size: 12 * 2px;
      line-height: 18 * 2px;
      text-align: left;
    }

    .resumeItem {
      margin-bottom: 8px;
      padding-left: 18px;
      position: relative;
    }

    .resumeItem::before {
      content: '•';
      position: absolute;
      left: 0;
      top: 0;
      color: #555555;
    }

    #qrcode {
      position: absolute;
      right: 45 * 2px;
      bottom: 40 * 2px;
    }

    .psimg {
      position: absolute;
      left: 50 * 2px;
      bottom: 40 * 2px;
      width: 213 * 2px;
    }

    .xiayin {
      position: absolute;
      right: 50 * 2px;
      bottom: 134 * 2px;
      transform: rotate(-180deg);
    }
  }
}
</style>
